import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Alpine from 'alpinejs';
import initMain from './sources/init-main';
import initAll from './sources/init-all';
import navigation from './sources/navigation';
import { InitCareer } from './sources/initCareer';
// jQuery 전역 등록
window.$ = $;
window.jQuery = $;

// Alpine 등록
window.Alpine = Alpine;
window.careerStatus = () => InitCareer.careerStatus();

Alpine.start();

const body = document.body;

const initSite = () => {
  initAll();
  navigation();
  if (body.classList.contains('home')) {
    initMain();
  }
};

window.addEventListener('load', () => {
  initSite();
});
